import { AuthReducer } from '../../shared/interfaces';
import auth from './auth-reducer';
import { billing, BillingState } from "./billing";
import dashboardInfo, { IReducerDashboardInfo } from './dashboardInfo';
import devicesData, { IReducerDevicesData } from './devicesData';
import devicesTripsPoints, { IReducerDevicesTripsPoints } from './devicesTripsPoints';
import { reducers as fences, iState as iFencesState } from './fences-reducers';
import { reducers as general, iState as iGeneralReducerState } from './general-reducers-fn';
import { reducers as gmap, iState as iGmapState } from './gmap-reducers';
import { reducer as gMapModal, iState as iGMapModalState } from "./gMapModal";
import { iState as iLayoutState, reducers as layout } from './layout-reducers';
import { iMaintenanceStore, reducer as maintenance } from "./maintenance";
import { iState as iMapPathState, reducers as paths } from './map-path-reducers';
import { iState as iMapRegionState, reducers as regions } from './map-region-reducers';
import replay, { IReplayPointState } from './replay';
import { iState as iReportState, reducers as report } from './report-reducers';
import selectedPoint, { IReducerSelectedPoint } from './selectedPoint';
import { iState as iTagItemState, reducers as tagItem } from './tag-item';
import tagsDevicesMap, { TagsDevicesMapReducer } from './tagsDevicesMap';
import { iState as iTimelineState, reducers as timeline } from './timeline-reducers';
import { iState as iUiState, reducers as ui } from './ui-reducers';
import { videoCameras, VideoCamerasState } from './videoCameras';
import { fencesContainerUIReducer, IFencesContainerUIState } from './fencesContainerUI-reducer';
import { mapLegendUIReducer, IMapLegendUIState } from './mapLegendUI-reducer';
import { kmlReducer, iKmlState } from './kml-reducers';

export { Actions as UiActions } from './ui-reducers';

export interface iReducersState {
  auth: AuthReducer;
  devicesData: IReducerDevicesData;
  tagsDevicesMap: TagsDevicesMapReducer;
  devicesTripsPoints: IReducerDevicesTripsPoints;
  selectedPoint: IReducerSelectedPoint;
  dashboardInfo: IReducerDashboardInfo;
  gmap: iGmapState;
  general: iGeneralReducerState;
  tagItem: iTagItemState;
  fences: iFencesState;
  regions: iMapRegionState;
  paths: iMapPathState;
  report: iReportState;
  layout: iLayoutState;
  timeline: iTimelineState;
  ui: iUiState;
  gMapModal: iGMapModalState;
  billing: BillingState;
  videoCameras: VideoCamerasState;
  maintenance: iMaintenanceStore;
  replay: IReplayPointState;
  fencesContainerUI: IFencesContainerUIState;
  mapLegendUI: IMapLegendUIState;
  kml: iKmlState;
}

export const reducers = {
  auth,
  devicesData,
  tagsDevicesMap,
  devicesTripsPoints,
  selectedPoint,
  dashboardInfo,
  general,
  gmap,
  tagItem,
  fences,
  regions,
  paths,
  report,
  layout,
  timeline,
  ui,
  gMapModal,
  billing,
  videoCameras,
  maintenance,
  replay: replay,
  fencesContainerUI: fencesContainerUIReducer,
  mapLegendUI: mapLegendUIReducer,
  kml: kmlReducer
};
